export enum ServiceStatus {
    Ini,
    Loading,
    Ok,
    Error   
}